import ENDPOINTS from 'api/endpoints';
import { doGet, doPatch } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { KnowledgeBaseRes, KnowledgeBaseUpdate } from './types';

export const getKnowledgeBase = (accountId: string, projectId: string) => {
  return doGet<KnowledgeBaseRes>(
    generateNextPath(ENDPOINTS.KNOWLEDGE_BASE, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const updateKnowledgeBase = ({
  accountId,
  projectId,
  update,
}: {
  accountId: string;
  projectId: string;
  update: KnowledgeBaseUpdate;
}) => {
  return doPatch<KnowledgeBaseRes>(
    generateNextPath(ENDPOINTS.KNOWLEDGE_BASE, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    update,
    { version: 'v2' },
  );
};
